import classnames from 'classnames';
import useStyles from './styles';
import Loading from '@/components/Loading';
import { LoadingVariant } from '@/components/Loading/types';
import type { CardSkeletonProps } from './types';

const CardSkeleton = ({
  isLoading,
  generationStartTime,
  presetType,
}: CardSkeletonProps) => {
  const classes = useStyles();
  const rootClassName = classnames(classes.root, classes.rootLoading);

  if (isLoading) {
    return (
      <div className={classes.rootLoading}>
        <div className={classes.loadingCardContainer}>
          <Loading
            variant={LoadingVariant.Compact}
            startTime={generationStartTime}
            mediaTypeOverride={presetType}
          />
        </div>
      </div>
    );
  }

  return (
    <div className={rootClassName}>
      <div className={classes.mediaContainer}>
        <div className={classes.skeletonWithTitle}>
          <div className={classes.skeletonMedia} />
          <div className={classes.skeletonTitle}>
            <div className={classes.skeletonTitleBar} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardSkeleton;
